import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styles from '../Login/Login.module.css';

export const Register: React.FC = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    tenantCode: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register({
        ...formData,
        phoneNumber: formData.phoneNumber || undefined,
      });
      navigate('/');
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Errore nella registrazione');
    } finally {
      setLoading(false);
    }
  };

  const update = (field: string, value: string) =>
    setFormData((prev) => ({ ...prev, [field]: value }));

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.logo}>Turna</h1>
        <p className={styles.subtitle}>Crea il tuo account</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          {error && <div className={styles.error}>{error}</div>}

          <div className={styles.field}>
            <label htmlFor="tenantCode">Codice Negozio</label>
            <input
              id="tenantCode"
              type="text"
              value={formData.tenantCode}
              onChange={(e) => update('tenantCode', e.target.value.toUpperCase())}
              placeholder="Es. BAR-ROMA-01"
              required
              disabled={loading}
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div className={styles.field}>
              <label htmlFor="firstName">Nome</label>
              <input
                id="firstName"
                type="text"
                value={formData.firstName}
                onChange={(e) => update('firstName', e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className={styles.field}>
              <label htmlFor="lastName">Cognome</label>
              <input
                id="lastName"
                type="text"
                value={formData.lastName}
                onChange={(e) => update('lastName', e.target.value)}
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className={styles.field}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={formData.email}
              onChange={(e) => update('email', e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={formData.password}
              onChange={(e) => update('password', e.target.value)}
              placeholder="Min. 8 caratteri"
              required
              minLength={8}
              disabled={loading}
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="phone">Telefono (opzionale)</label>
            <input
              id="phone"
              type="tel"
              value={formData.phoneNumber}
              onChange={(e) => update('phoneNumber', e.target.value)}
              disabled={loading}
            />
          </div>

          <button type="submit" className={styles.button} disabled={loading}>
            {loading ? 'Registrazione...' : 'Registrati'}
          </button>
        </form>

        <p className={styles.link}>
          Hai gia' un account? <Link to="/login">Accedi</Link>
        </p>
      </div>
    </div>
  );
};
